import { Checkbox, Form, Text } from 'react-form'
import { adminPath } from '@shared/adminPath'
import React, { Component } from 'react'
import { closeLoader, openLoader } from '@actions/loader.js'
import { closeModal, openModal } from '@actions/modal.js'
import { createNotification, getNotificationById, updateNotification, uploadImage } from '@services/sm-api'
import { getSchoolList } from '@services/sm-auth'

import ConfirmDialog from '@shared/ConfirmDialog'
import { Editor } from '@tinymce/tinymce-react'
import { connect } from 'react-redux'
import { withRouter } from '../../utils/withRouter'
import { showToastNotification } from '../../actions/toastNotification'

const EDITOR_MAX_CHARS = 2000;
const EDITOR_MAX_UPLOADED_IMAGES = 3;
const EDITOR_ALLOWED_FILES_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
const EDITOR_MAX_FILESIZE = 1024 * 1024;

class NotificationForm extends Component {
  constructor(props) {
    super(props)

    this.hideDefaultError = { style: { display: 'none' } }

    this.state = {
      message: '',
      editorNumberOfChars: 0,
      schools: [],
      school_id: null,
    }

    this.submitMethods = {
      CREATE: createNotification,
      UPDATE: updateNotification,
    }
  }

  _preProcess = notificationId => {
    return getNotificationById(notificationId)
      .then(({ notification: { title, message, block_checkout, is_active, school_id } }) => {
        this.setState(
          {
            message,
            school_id: school_id || null,
          },
          () => {
            this.refs.Form.setAllValues({
              title,
              message,
              block_checkout,
              is_active,
            })
          },
        )
      })
      .catch(({ response }) => {
        let errorMessage = 'Erro ao exibir a notificação. Tente novamente mais tarde'

        if (response.data && response.status === 404) {
          errorMessage = 'Notificação não encontrado.'
        }

        this.props.openModal(
          <ConfirmDialog
            text={errorMessage}
            okLabel="Confirmar"
            ok={() => {
              this.props.closeModal()
              this.props.navigate(adminPath('/notifications'))
            }}
          />,
        )
      })
  }

  _isEmpty = field => (field ? null : 'Este campo é obrigatório')

  /**
   * All validations rules
   **/
  _validateForm = values => {
    const { title } = values

    let errors = {
      title: this._isEmpty(title),
      message: this._isEmpty(this.state.message),
    }

    return errors
  }

  _handleEdit(values) {
    const { editMode, openModal, navigate, params } = this.props

    if (this.state.editorNumberOfChars >= EDITOR_MAX_CHARS) {
      this.props.showToastNotification({
        title: 'Alerta',
        text: `Sua mensagem é muito grande e tem mais de ${EDITOR_MAX_CHARS} caracteres. Reduza antes de enviar novamente`,
        variant: 'warning'
      });
      return;
    }

    let payload = {
      title: values.title,
      message: this.state.message,
      block_checkout: values.block_checkout || 0,
      is_active: values.is_active || 0,
      school_id: this.state.school_id || null,
    }

    if (editMode === 'UPDATE') {
      payload.id = params.id
    }

    this.submitMethods[editMode](payload)
      .then(() => {
        openModal(
          <ConfirmDialog
            text="Notificação salvo com sucesso."
            okLabel="OK"
            ok={() => {
              this.props.closeModal()
              navigate(adminPath('/notifications'))
            }}
          />,
        )
      })
      .catch(error => {
        let errorMessage = 'Problemas ao salvar a notificação. Tente novamente mais tarde.'

        openModal(
          <ConfirmDialog
            text={errorMessage}
            okLabel="OK"
            ok={() => {
              this.props.closeModal()
            }}
          />,
        )
      })
  }

  componentDidMount() {
    const { openLoader, closeLoader, params } = this.props
    openLoader()

    const schoolsPromise = getSchoolList().then(response => {
      const sortedSchools = [...response].sort((a, b) => Number(a.id) - Number(b.id))
      const schools = [{ label: 'Todas as escolas', value: null }, ...sortedSchools.map(school => ({
        label: `${school.id} - ${school.fantasy_name}`,
        value: school.id,
      }))]
      this.setState({ schools })
    })

    if (params.id) {
      Promise.all([this._preProcess(params.id), schoolsPromise]).finally(closeLoader)
    } else {
      schoolsPromise.finally(closeLoader)
    }
  }

  checkFileAcceptanceCriterias (blobInfo) {
    if (this.state.message.match(/;base64,/g)?.length >= EDITOR_MAX_UPLOADED_IMAGES) {
      return `Você atingiu o limite de imagens enviadas para esta mensagem`;
    }

    if (!EDITOR_ALLOWED_FILES_MIME_TYPES.includes(blobInfo.blob().type)) {
      return `Formato de arquivo não permitido`;
    }

    if (blobInfo.blob().size > EDITOR_MAX_FILESIZE) {
      return `A imagem não pode ultrapassar 1MB`;
    }

    return true;
  }

  render() {
    const { title, params } = this.props

    return (
      <div className="notification-form">
        <Form
          ref="Form"
          validate={this._validateForm}
          onSubmit={values => {
            this._handleEdit(values)
          }}
        >
          {({ submitForm, swapTo, setValue, getValue, values }) => {
            return (
              <form className="admin-form__form" style={{ maxWidth: '1000px' }} onSubmit={submitForm}>
                <div className="admin-form__header">
                  <h1 className="admin-form__title">{title}</h1>
                </div>
                <div className="field">
                  <span className="field__label admin-form__form__label">Título</span>
                  <Text className="field__text" field="title" autoComplete="off" />
                </div>
                <div className="field">
                  <span className="field__label admin-form__form__label">Mensagem</span>
                  <Editor
                    apiKey='pug5llflmige8fv8tml2wg7t9053bgekkvurt64wxfgdg3sl'
                    value={this.state.message}
                    init={{
                      setup: (ed) => {
                        ed.on('keydown', (e) => {
                          const editorNumberOfChars = ed.plugins.wordcount.body.getCharacterCountWithoutSpaces()
                          document.querySelector('.tox-statusbar__branding').innerHTML = `- ${editorNumberOfChars} caracteres`
                          this.setState({
                            editorNumberOfChars,
                          })
                        });
                      },
                      height: 350,
                      menubar: false,
                      plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen textcolor',
                        'insertdatetime media table paste code help wordcount',
                      ],
                      toolbar:
                        'undo redo | bold italic underline | forecolor backcolor | fontselect fontsizeselect | link image | removeformat | code | help',
                      image_title: true,
                      language: 'pt_BR',
                      automatic_uploads: true,
                      file_picker_types: 'image',
                      paste_data_images: true,
                      images_upload_handler: (blobInfo, success, failure) => {
                        const { blob, filename, base64 } = blobInfo;

                        if (blob().name) {
                          const fileCheckerResult = this.checkFileAcceptanceCriterias(blobInfo);
                          if (fileCheckerResult !== true) {
                            return failure(fileCheckerResult);
                          }
                        }

                        const formData = new FormData()
                        formData.append('file', blob(), filename());

                        success(`data:${blob().type};base64,${base64()}`);
                      },
                    }}
                    onEditorChange={message => {
                      this.setState({ message })
                    }}
                  />
                </div>
                <div className="field">
                  <span className="field__label admin-form__form__label">Escola</span>
                  <div className="field__select">
                    <select
                      style={{background:"white"}}
                      className="field__text"
                      value={this.state.school_id || ''}
                      onChange={e => this.setState({ school_id: e.target.value || null })}
                    >
                      {this.state.schools.map(school => (
                        <option key={school.value} value={school.value || ''}>
                          {school.label}
                        </option>
                      ))}
                    </select>
                    * Ao selecionar uma escola, a notificação será exibida após o usuário adicionar um voucher referente a esta escola.
                  </div>
                </div>
                <div className="field field__block_checkout">
                  <label>
                    <Checkbox field="block_checkout" className="field__checkbox" />
                    <span className="field__checkbox__label">Bloquear checkout?</span>
                  </label>
                </div>
                <div className="field field__is_active">
                  <label>
                    <Checkbox field="is_active" className="field__checkbox" />
                    <span className="field__checkbox__label">Ativo?</span>
                  </label>
                </div>

                <div className="field">
                  <hr className="admin-form__division" />
                </div>
                <div className="field__submit">
                  <button className="admin-form__button button__normal" type="submit">
                    Salvar
                  </button>
                </div>
              </form>
            )
          }}
        </Form>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  sessionReducer: state.sessionReducer,
  user: state.user,
})

const mapDispatchToProps = {
  openLoader, 
  closeLoader,
  openModal,
  closeModal,
  showToastNotification,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NotificationForm))

